import { render, staticRenderFns } from "./MmTwoBeta.vue?vue&type=template&id=0949aaec"
import script from "./MmTwoBeta.vue?vue&type=script&lang=js"
export * from "./MmTwoBeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports